module.exports = __webpack_public_path__ + "img/tech_2.e544aa36.jpg";